module.exports = __webpack_public_path__ + "img/jameson-logo-age-confirm.b5e03439.png";